// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35aBG","delete":"styles_delete__2h8PC","update":"styles_update__2qv4-","add":"styles_add__1c5v_"};